export default class SingleStyler {
    /**
     * 
     * @param styler 
     * @param style 
     * @param feature 
     * @param layerViewInfo 
     * 
     * @returns 
     */
    getStyle(styler, style, feature, layerViewInfo) {
        return styler.style;
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getPaddingPx(styler) {
        return es.util.style.types[styler.style.$type].getPaddingPx(styler.style);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasDirect(styler) {
        return es.util.style.types[styler.style.$type].hasDirect(styler.style);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasOverlays(styler) {
        return es.util.style.types[styler.style.$type].hasOverlays(styler.style);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getHideFeaturesCriteria(styler) {
        return null;
    }
}
